// import React, { Fragment, useContext, useEffect, useState } from 'react';
// import { useTranslation } from 'react-i18next';
// import { Link } from 'react-router-dom';
// import SvgIcon from '../../Components/Common/Component/SvgIcon';
// import CustomizerContext from '../../_helper/Customizer';
// import { MENUITEMS } from './Menu';

// const SidebarMenuItems = ({ setMainMenu, sidebartoogle, setNavActive, activeClass }) => {
//   const { layout } = useContext(CustomizerContext);
//   const layout1 = localStorage.getItem('sidebar_layout') || layout;

//   const [navScreens, setNavScreens] = useState([]);

//   console.log(navScreens)

//   const id = window.location.pathname.split('/').pop();
//   const layoutId = id;
//   const CurrentPath = window.location.pathname;

//   const { t } = useTranslation();
//   const toggletNavActive = (item) => {
//     if (window.innerWidth <= 991) {
//       document.querySelector('.page-header').className = 'page-header close_icon';
//       document.querySelector('.sidebar-wrapper').className = 'sidebar-wrapper close_icon ';
//       document.querySelector('.mega-menu-container').classList.remove('d-block');
//       if (item.type === 'sub') {
//         document.querySelector('.page-header').className = 'page-header';
//         document.querySelector('.sidebar-wrapper').className = 'sidebar-wrapper';
//       }
//     }
//     if (!item.active) {
//       MENUITEMS.map((a) => {
//         a.Items.filter((Items) => {
//           if (a.Items.includes(item)) Items.active = false;
//           if (!Items.children) return false;
//           Items.children.forEach((b) => {
//             if (Items.children.includes(item)) {
//               b.active = false;
//             }
//             if (!b.children) return false;
//             b.children.forEach((c) => {
//               if (b.children.includes(item)) {
//                 c.active = false;
//               }
//             });
//           });
//           return Items;
//         });
//         return a;
//       });
//     }
//     item.active = !item.active;
//     setMainMenu({ mainmenu: MENUITEMS });
//   };

//   // function getPermissions() {
//   //   let roles_permissions = localStorage.getItem("user_permission_data");
//   //   if (roles_permissions !== null && roles_permissions !== undefined) {
//   //     let permissions = JSON.parse(roles_permissions);
      
//   //     let data_ = [];
//   //     let navs = MENUITEMS.map(menu => menu.Items)  ;
//   //     for (let i = 0; i < permissions.length; i++) {
//   //       for (let j = 0; j < navs.length; j++) {
//   //         if (
//   //           permissions[i]["module_name"] === navs[j]["title"] &&
//   //           permissions[i]["view_access"] === true
//   //         ) {
//   //           navs[j]["view_access"] = permissions[i]["view_access"].toString();
//   //           navs[j]["create_access"] = permissions[i]["create_access"].toString();
//   //           navs[j]["edit_access"] = permissions[i]["edit_access"].toString();
//   //           navs[j]["delete_access"] = permissions[i]["delete_access"].toString();
//   //           data_.push(navs[j]);
//   //         }
//   //       }
//   //     }
//   //     setNavScreens(data_);
//   //   }
//   // }

//   function getPermissions() {
//     let roles_permissions = localStorage.getItem("user_permission_data");
//     if (roles_permissions !== null && roles_permissions !== undefined) {
//       let permissions = JSON.parse(roles_permissions);
//       let data_ = [];
  
//       // Helper function to filter and set access on menus and their submenus
//       const filterMenuItems = (items, permissions) => {
//         return items.map((item) => {
//           let permission = permissions.find((perm) => perm["module_name"] === item["title"]);
//           if (permission && permission["view_access"]) {
//             return {
//               ...item,
//               view_access: permission["view_access"].toString(),
//               create_access: permission["create_access"].toString(),
//               edit_access: permission["edit_access"].toString(),
//               delete_access: permission["delete_access"].toString(),
//               children: item.children ? filterMenuItems(item.children, permissions) : []
//             };
//           }
//         }).filter(Boolean); // Remove items without view access
//       };
  
//       // Iterate over each menu in MENUITEMS and process its Items
//       MENUITEMS.forEach((menu) => {
//         let filteredItems = filterMenuItems(menu.Items, permissions);
//         if (filteredItems.length > 0) {
//           data_.push({ ...menu, Items: filteredItems });
//         }
//       });
  
//       // Set the filtered and accessible menu data
//       setNavScreens(data_);
//     }
//   }
  

//   useEffect(()=>{
//     getPermissions()
//   },[])

//   return (
//     <>
//    {navScreens.map((Item, i) => (
//   <Fragment key={i}>
//     {Item.Items.some(menuItem => menuItem.view_access !== false) && ( // Ensure there's at least one accessible item
//       <>
//         <li className='sidebar-main-title'>
//           <div>
//             <h6 className='lan-1'>{t(Item.menutitle)}</h6>
//           </div>
//         </li>
        
//         {Item.Items.filter(menuItem => menuItem.view_access !== false).map((menuItem, i) => ( // Filter out items with view_access false
//           <li className='sidebar-list' key={i}>
//             {menuItem.type === 'sub' ? (
//               <a
//                 href='javascript'
//                 className={`sidebar-link sidebar-title ${CurrentPath.includes(menuItem.title.toLowerCase()) ? 'active' : ''} ${menuItem.active && 'active'}`}
//                 onClick={(event) => {
//                   event.preventDefault();
//                   setNavActive(menuItem);
//                   activeClass(menuItem.active);
//                 }}>
//                 <SvgIcon className='stroke-icon' iconId={`stroke-${menuItem.icon}`} />
//                 <SvgIcon className='fill-icon' iconId={`fill-${menuItem.icon}`} />
//                 <span>{t(menuItem.title)}</span>
//                 {menuItem.badge ? <label className={menuItem.badge}>{menuItem.badgetxt}</label> : ''}
//                 <div className='according-menu'>{menuItem.active ? <i className='fa fa-angle-down'></i> : <i className='fa fa-angle-right'></i>}</div>
//               </a>
//             ) : (
//               ''
//             )}

//             {menuItem.type === 'link' ? (
//               <Link to={menuItem.path + '/' + layoutId} className={`sidebar-link sidebar-title link-nav  ${CurrentPath.includes(menuItem.title.toLowerCase()) ? 'active' : ''}`} onClick={() => toggletNavActive(menuItem)}>
//                 <SvgIcon className='stroke-icon' iconId={`stroke-${menuItem.icon}`} />
//                 <SvgIcon className='fill-icon' iconId={`fill-${menuItem.icon}`} />
//                 <span>{t(menuItem.title)}</span>
//                 {menuItem.badge ? <label className={menuItem.badge}>{menuItem.badgetxt}</label> : ''}
//               </Link>
//             ) : (
//               ''
//             )}

//             {menuItem.children ? (
//               <ul className='sidebar-submenu' style={layout1 !== 'compact-sidebar compact-small' ? (menuItem?.active || CurrentPath.includes(menuItem?.title?.toLowerCase()) ? (sidebartoogle ? { opacity: 1, transition: 'opacity 500ms ease-in' } : { display: 'block' }) : { display: 'none' }) : { display: 'none' }}>
//                 {menuItem.children.filter(childrenItem => childrenItem.view_access !== false).map((childrenItem, index) => ( // Filter child items
//                   <li key={index}>
//                     {childrenItem.type === 'sub' ? (
//                       <a
//                         href='javascript'
//                         className={`${CurrentPath.includes(childrenItem?.title?.toLowerCase()) ? 'active' : ''}`}
//                         onClick={(event) => {
//                           event.preventDefault();
//                           toggletNavActive(childrenItem);
//                         }}>
//                         {t(childrenItem.title)}
//                         <span className='sub-arrow'>
//                           <i className='fa fa-chevron-right'></i>
//                         </span>
//                         <div className='according-menu'>{childrenItem.active ? <i className='fa fa-angle-down'></i> : <i className='fa fa-angle-right'></i>}</div>
//                       </a>
//                     ) : (
//                       ''
//                     )}

//                     {childrenItem.type === 'link' ? (
//                       <Link
//                         to={childrenItem.path + '/' + layoutId}
//                         className={`${CurrentPath.includes(childrenItem?.title?.toLowerCase()) ? 'active' : ''}`}
//                         onClick={() => toggletNavActive(childrenItem)}>
//                         {t(childrenItem.title)}
//                       </Link>
//                     ) : (
//                       ''
//                     )}

//                     {childrenItem.children ? (
//                       <ul className='nav-sub-childmenu submenu-content' style={CurrentPath.includes(childrenItem?.title?.toLowerCase()) || childrenItem.active ? { display: 'block' } : { display: 'none' }}>
//                         {childrenItem.children.filter(childrenSubItem => childrenSubItem.view_access !== false).map((childrenSubItem, key) => ( // Filter sub-child items
//                           <li key={key}>
//                             {childrenSubItem.type === 'link' ? (
//                               <Link
//                                 to={childrenSubItem.path + '/' + layoutId}
//                                 className={`${CurrentPath.includes(childrenSubItem?.title?.toLowerCase()) ? 'active' : ''}`}
//                                 onClick={() => toggletNavActive(childrenSubItem)}>
//                                 {t(childrenSubItem.title)}
//                               </Link>
//                             ) : (
//                               ''
//                             )}
//                           </li>
//                         ))}
//                       </ul>
//                     ) : (
//                       ''
//                     )}
//                   </li>
//                 ))}
//               </ul>
//             ) : (
//               ''
//             )}
//           </li>
//         ))}
//       </>
//     )}
//   </Fragment>
// ))}


     
//     </>
//   );
// };

// export default SidebarMenuItems;

import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import SvgIcon from '../../Components/Common/Component/SvgIcon';
import CustomizerContext from '../../_helper/Customizer';
import { MENUITEMS } from './Menu';

const SidebarMenuItems = ({ setMainMenu, sidebartoogle, setNavActive, activeClass }) => {
  const { layout } = useContext(CustomizerContext);
  const layout1 = localStorage.getItem('sidebar_layout') || layout;

  const [navScreens, setNavScreens] = useState([]);

  const id = window.location.pathname.split('/').pop();
  const layoutId = id;
  const CurrentPath = window.location.pathname;
  const { t } = useTranslation();

  const toggletNavActive = (item) => {
    if (window.innerWidth <= 991) {
      document.querySelector('.page-header').className = 'page-header close_icon';
      document.querySelector('.sidebar-wrapper').className = 'sidebar-wrapper close_icon ';
      document.querySelector('.mega-menu-container').classList.remove('d-block');
      if (item.type === 'sub') {
        document.querySelector('.page-header').className = 'page-header';
        document.querySelector('.sidebar-wrapper').className = 'sidebar-wrapper';
      }
    }

    if (!item.active) {
      MENUITEMS.forEach((menu) => {
        menu.Items.forEach((menuItem) => {
          if (menuItem !== item) {
            menuItem.active = false;
            if (menuItem.children) {
              menuItem.children.forEach((subItem) => {
                subItem.active = false;
                if (subItem.children) {
                  subItem.children.forEach((subSubItem) => (subSubItem.active = false));
                }
              });
            }
          }
        });
      });
    }
    item.active = !item.active;
    setMainMenu({ mainmenu: MENUITEMS });
  };

  const getPermissions = () => {
    const roles_permissions = localStorage.getItem('user_permission_data');
    if (roles_permissions) {
      const permissions = JSON.parse(roles_permissions);
      const data_ = [];

      const filterMenuItems = (items) => {
        return items
          .map((item) => {
            const permission = permissions.find((perm) => perm['module_name'] === item['title']);
            if (permission && permission['view_access']) {
              const filteredChildren = item.children ? filterMenuItems(item.children) : [];
  

              console.log(filteredChildren)
              return {
                ...item,
                view_access: permission['view_access'].toString(),
                create_access: permission['create_access'].toString(),
                edit_access: permission['edit_access'].toString(),
                delete_access: permission['delete_access'].toString(),
                children: filteredChildren.length > 0 ? filteredChildren : undefined
              };
            }
            return null;
          })
          .filter(Boolean);
      };

      MENUITEMS.forEach((menu) => {
        const filteredItems = filterMenuItems(menu.Items);
        if (filteredItems.length > 0) {
          data_.push({ ...menu, Items: filteredItems });
        }
      });

      console.warn(data_)

      setNavScreens(data_);
    }
  };

//   const getPermissions = () => {
//     const roles_permissions = localStorage.getItem('user_permission_data');
//     if (roles_permissions) {
//         const permissions = JSON.parse(roles_permissions);
//         const data_ = [];

//         const filterMenuItems = (items) => {
//             return items
//                 .map((item) => {
//                     const permission = permissions.find((perm) => perm['module_name'] === item['title']);
//                     const hasViewAccess = permission && permission['view_access'];

//                     // Check for specific parent titles
//                     const shouldFilterChildren = item.title === "General Category Settings" || item.title === "Treatment Settings";
                    
//                     // Filter children recursively if the item is one of the specified titles
//                     const filteredChildren = shouldFilterChildren && item.children ? filterMenuItems(item.children) : [];

//                     // Include item if it has view access or if it has children with view access
//                     if (hasViewAccess || (shouldFilterChildren && filteredChildren.length > 0)) {
//                         return {
//                             ...item,
//                             view_access: hasViewAccess ? permission['view_access'].toString() : undefined,
//                             create_access: hasViewAccess ? permission['create_access'].toString() : undefined,
//                             edit_access: hasViewAccess ? permission['edit_access'].toString() : undefined,
//                             delete_access: hasViewAccess ? permission['delete_access'].toString() : undefined,
//                             children: filteredChildren.length > 0 ? filteredChildren : undefined,
//                         };
//                     }
//                     return null;
//                 })
//                 .filter(Boolean);
//         };

//         // First level of MENUITEMS
//         MENUITEMS.forEach((menu) => {
//             const filteredItems = filterMenuItems(menu.Items);
//             if (filteredItems.length > 0) {
//                 data_.push({ ...menu, Items: filteredItems });
//             }
//         });

//         console.warn(data_);
//         setNavScreens(data_);
//     }
// };


  // console.warn(navScreens)

  useEffect(() => {
    getPermissions();
  }, []);

  return (
    <>
      {navScreens.map((menuGroup, i) => (
        <Fragment key={i}>
          {menuGroup.Items.some((menuItem) => menuItem.view_access === 'true') && (
            <>
              <li className="sidebar-main-title">
                <div>
                  <h6>{t(menuGroup.menutitle)}</h6>
                </div>
              </li>
              {menuGroup.Items.filter((menuItem) => menuItem.view_access === 'true').map((menuItem, i) => (
                <li className="sidebar-list" key={i}>
                  {menuItem.type === 'sub' ? (
                    <a
                      href="#"
                      className={`sidebar-link sidebar-title ${CurrentPath.includes(menuItem.title.toLowerCase()) ? 'active' : ''}`}
                      onClick={(event) => {
                        event.preventDefault();
                        setNavActive(menuItem);
                        activeClass(menuItem.active);
                      }}>
                      <SvgIcon className="stroke-icon" iconId={`stroke-${menuItem.icon}`} />
                      <SvgIcon className="fill-icon" iconId={`fill-${menuItem.icon}`} />
                      <span>{t(menuItem.title)}</span>
                      {menuItem.badge && <label className={menuItem.badge}>{menuItem.badgetxt}</label>}
                      <div className="according-menu">
                        {menuItem.active ? <i className="fa fa-angle-down"></i> : <i className="fa fa-angle-right"></i>}
                      </div>
                    </a>
                  ) : null}

                  {menuItem.type === 'link' ? (
                    <Link
                      to={menuItem.path + '/' + layoutId}
                      className={`sidebar-link sidebar-title link-nav ${CurrentPath.includes(menuItem.title.toLowerCase()) ? 'active' : ''}`}
                      onClick={() => toggletNavActive(menuItem)}>
                      <SvgIcon className="stroke-icon" iconId={`stroke-${menuItem.icon}`} />
                      <SvgIcon className="fill-icon" iconId={`fill-${menuItem.icon}`} />
                      <span>{t(menuItem.title)}</span>
                      {menuItem.badge && <label className={menuItem.badge}>{menuItem.badgetxt}</label>}
                    </Link>
                  ) : null}

                  {menuItem.children && (
                    <ul
                      className="sidebar-submenu"
                      style={
                        layout1 !== 'compact-sidebar compact-small'
                          ? menuItem.active || CurrentPath.includes(menuItem.title.toLowerCase())
                            ? sidebartoogle
                              ? { opacity: 1, transition: 'opacity 500ms ease-in' }
                              : { display: 'block' }
                            : { display: 'none' }
                          : { display: 'none' }
                      }>
                      {menuItem.children
                        .filter((childItem) => childItem.view_access === 'true')
                        .map((childItem, index) => (
                          <li key={index}>
                            {childItem.type === 'link' ? (
                              <Link
                                to={childItem.path + '/' + layoutId}
                                className={`${CurrentPath.includes(childItem.title.toLowerCase()) ? 'active' : ''}`}
                                onClick={() => toggletNavActive(childItem)}>
                                {t(childItem.title)}
                              </Link>
                            ) : null}
                          </li>
                        ))}
                    </ul>
                  )}
                </li>
              ))}
            </>
          )}
        </Fragment>
      ))}
    </>
  );
};

export default SidebarMenuItems;
